import React, { useState, useEffect } from 'react';
import { SVGUser, SVGUserOutline } from '../components/SVG';

export default function UserPicture({ pictureSrc = null, initials = null, colour = null }) {

    let colourClass;
    switch (colour) {
        case 'amber':
            colourClass = 'user-picture__amber';
            break;
        case 'red':
            colourClass = 'user-picture__red';
            break;
        case 'blue':
            colourClass = 'user-picture__blue';
            break;
        case 'purple':
            colourClass = 'user-picture__purple';
            break;
        case 'lime':
            colourClass = 'user-picture__lime';
            break;
        case 'teal':
        default:
            colourClass = 'user-picture__teal';
            break;
    }

    return (
        <div className={`${colourClass} relative w-full flex justify-center items-center aspect-square rounded-full
            after:absolute after:w-full after:h-full after:top-0 after:left-0 after:rounded-full after:border-[1px] after:border-black/10`}>
            { pictureSrc ? (
                    <img src={pictureSrc} className='w-full h-full object-cover rounded-full' />
                ) : (
                    initials ? (
                    <span className='text-[0.7em] font-bold tracking-wider'>{initials}</span>
                ) : (
                    <SVGUserOutline classes='h-[50%]' />
                )
            )}
        </div>
    );
}